
import { Component, Input } from '@angular/core';

import { Attachment } from '../models/attachment.model';

@Component({
  selector: 'attachment-display',
  template: require('./attachment-display.component.html'),
  styles: [require('./attachment-display.component.scss')],
})

export class AttachmentDisplayComponent {
  @Input() attachment: Attachment = null;

  get attachmentType(): string {
    return this.getFileType(this.attachment.file);
  }

  getFileType(fileName: string): string {
    switch (fileName.split('.').pop())
    {
      case 'doc':
      case 'docx':
        return 'doc';

      case 'xls':
      case 'xlsx':
      case 'xlsm':
        return 'spreadsheet';

      case 'pdf':
        return 'pdf';

      case 'zip':
      case 'rar':
        return 'archive';

      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'tiff':
      case 'gif':
      case 'webp':
        return 'picture';

      case 'mov':
      case 'avi':
      case 'webm':
      case 'wmv':
      case 'mkv':
      case 'flv':
      case 'mp4':
      case 'mpeg':
      case 'mpg':
      case 'm4v':
        return 'video';

      case 'ppt':
      case 'pptx':
        return 'slides';

      default:
        return 'other';
    }
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/attachment-display/attachment-display.component.ts